import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import ModalAlert from 'modules/_shared/components/ModalAlert';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import PartnersTableView from './PartnersTableView';
import DividendBounceRetryFilterWarning from './DividendBounceRetryFilterWarning';
import { useNotifyPartnersDividendsModal } from '../context/NotifyPartnersDividendsModalContext';

const NotifyPartnersDividendsModalBody: FC = () => {
  const { data, actions } = useNotifyPartnersDividendsModal();

  const showPagination = data.expandView && data.totalPartners > 10;

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.showBounceRetryWarning && (
          <DividendBounceRetryFilterWarning
            allowedEmails={data.bounceRetryAllowedEmails}
          />
        )}

        <PartnersTableView />

        {showPagination && (
          <TablePagination
            totalRows={data.totalPartners || 0}
            onChangePage={actions.handleChangePage}
            onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          />
        )}
        {data.hasInvalidEmails && (
          <ModalAlert text={data.invalidEmailsAlert} hasCloseButton />
        )}
        {data.hasGeneratedEmails && (
          <ModalAlert text={data.generatedEmailsAlert} hasCloseButton />
        )}
      </div>
    </Modal.Body>
  );
};

export default NotifyPartnersDividendsModalBody;
